import { RelatedObjects } from '@sweep-io/sweep-design/dist/icons';
import { CanvasToolbarButton } from './CanvasToolbarButton';
import { usePanels } from '../../../../panels/usePanels';
import { useHandleCommentsAndAiFirst } from '../left-menu/useHandleCommentsAndAiFirst';
import { metadataElementsPanelType } from '../../../funnel-map-flow/dialogs/metadata-elements/metadataElementsPanelType';
import { useCanvasToolbarContext } from './CanvasToolbarCtx';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectUserInfoData } from '../../../../../reducers/userInfoReducer';
import { AccountType } from '@server/account-type';
import { usePermissions } from '../../../../../permissions/usePermissions';

export const MetadataElementsToolbarButton = ({ isDisabled }: { isDisabled?: boolean }) => {
  const userInfo = useSelector(selectUserInfoData);
  const isFreeUser = userInfo?.account?.type === AccountType.Free; //by product definition should block all (both trial and non trial users) free users

  const { maybeOpenPanel } = usePanels();
  const handleCommentsAndAiFirst = useHandleCommentsAndAiFirst();
  const { isPanelOpen, maybeCloseSpecificPanel } = usePanels();
  const isMetadataElementsPanelOpen = isPanelOpen(metadataElementsPanelType);
  const { hasEveryPermission } = usePermissions();

  const hasFunnelMapPermissions = hasEveryPermission([{ permission: ['edit:funnel-maps', 'edit:funnel-maps:links'] }]);

  const { activeExclusiveButton, setActiveExclusiveButton } = useCanvasToolbarContext();

  useEffect(() => {
    if (activeExclusiveButton !== 'metadataElements' && isMetadataElementsPanelOpen) {
      maybeCloseSpecificPanel(metadataElementsPanelType);
    }
  }, [
    activeExclusiveButton,
    isMetadataElementsPanelOpen,
    maybeCloseSpecificPanel,
    setActiveExclusiveButton,
  ]);

  if (isFreeUser) {
    return null;
  }

  return (
    <CanvasToolbarButton
      tooltip="Add Metadata Elements"
      disabledTooltip={
        hasFunnelMapPermissions ? '' : 'To add Metadata Elements, please contact your admin.'
      }
      onToggle={(pressed: boolean) => {
        if (pressed) {
          handleCommentsAndAiFirst(() => {
            maybeOpenPanel({
              panelType: metadataElementsPanelType,
              onOpen: () => setActiveExclusiveButton('metadataElements'),
              onClose: () => setActiveExclusiveButton(null),
            });
          });
        } else {
          maybeCloseSpecificPanel(metadataElementsPanelType, undefined, { forceClose: true });
        }
      }}
      pressed={isMetadataElementsPanelOpen}
      disabled={!hasFunnelMapPermissions || isDisabled}
      testId="add-metadata-elements-button"
    >
      <RelatedObjects />
    </CanvasToolbarButton>
  );
};
